import React, { useEffect, useState } from "react";
import PortfolioItem from "../components/PortfolioItem";
import portfolios from "../utils/portfolios";

function PortfolioPage() {
  const [filter, setFilter] = useState("all");
  const [project, setProject] = useState([]);

  useEffect(() => {
    setProject([]);

    const filtered = portfolios.filter((p) => {
      return p.category.includes(filter);
    });
    setProject(filtered);
  }, [filter]);
  return (
    <div className="tokyo_tm_section">
      <div className="container">
        <div className="tokyo_tm_portfolio">
          <div className="portfolio_filter">
            <div className="p_wrapper">
              <div className="tokyo_tm_title">
                <div className="title_flex">
                  <div className="left">
                    <span>Portfolio</span>
                    <h3>Creative Portfolio</h3>
                  </div>
                </div>
              </div>
              <ul className="filter_list">
                <li
                  className={filter === "all" ? "active" : ""}
                  onClick={() => setFilter("all")}>
                  All
                </li>
                <li
                  className={filter === "design" ? "active" : ""}
                  onClick={() => setFilter("design")}>
                  Design
                </li>
                <li
                  className={filter === "web" ? "active" : ""}
                  onClick={() => setFilter("web")}>
                  Website
                </li>
                <li
                  className={filter === "mobile" ? "active" : ""}
                  onClick={() => setFilter("mobile")}>
                  Mobile
                </li>
                <li
                  className={filter === "other" ? "active" : ""}
                  onClick={() => setFilter("other")}>
                  Other
                </li>
              </ul>
            </div>
            <div className="list_wrapper">
              <ul
                className="portfolio_list aos-init aos-animate"
                data-aos="fade-right"
                data-aos-duration="1200">
                {project.map((p) => (
                  <PortfolioItem
                    image={p.imgUrl}
                    description={p.desc}
                    alt={p.alt}
                    title={p.title}
                    key={p.id}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PortfolioPage;
